import { useSelector } from 'react-redux'
import Layout from '../../../components/Layout'
import ConstantConsumptionStyle from '../Create/ConstantConsumption'
import { useEffect, useRef, useState } from 'react'
import { ClipLoader } from 'react-spinners'
import { get } from 'lodash'
import { removeSpaces } from '../../../utils/removeSpaces'
import { formatNumberWithIntl } from '../../../lib/FormatNumbersWithIntl'
import api from '../../../api'
import { ErrorModal, SuccessModal } from '../../../components/Modal'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/Button'
import { BG_COLOR } from '../../../constants/colors'
import { Spin } from 'antd'

export default function CreateDraftJournalEntries() {
	const { getMe } = useSelector((state) => state.main)
	const navigation = useNavigate()
	const successModalRef = useRef()
	const errorRef = useRef()

	const senderId = getMe?.EmployeeID

	const employeeId = get(getMe, 'EmployeeID', '')

	const kassaList = getMe?.U_CashOut?.split(',')
	const kassaFilter = kassaList
		?.filter(Boolean)
		?.map((code) => `Code eq '${code}'`)
		?.join(' or ')

	const defaultDate = new Date().toISOString().split('T')[0]
	const defaultCurrency = getMe?.U_Currency || 'USD'
	const [employeeData, setEmployeeData] = useState([])

	const [isLoading, setIsLoading] = useState(false)
	const [isSubmitting, setIsSubmitting] = useState(false)
	const [cashAccountsData, setCashAccountsData] = useState([])
	const [spendAccountsData, setSpendAccountsData] = useState([])
	const [formData, setFormData] = useState({
		LineId: 1,
		U_PaidSum: '',
		U_Currency: defaultCurrency,
		U_Date: defaultDate,
		U_FromAccount: '', // C кассы (eskisi bilan 1 vs 1)
		U_ToAccount: '', // На сейф (eskisi bilan 1 vs 1)
		U_Comment: '',
		// U_Sent: 'Yes', // Har doyim Yes
		// U_Received: 'Yes', // Har doyim Yes
	})

	useEffect(() => {
		if (!kassaList?.length)
			return errorRef.current?.open(
				'Список касс пуст у пользователя(U_CashOut)',
			)
		;(async () => {
			setIsLoading(true)
			await api
				.get(
					`ChartOfAccounts?$select=Code,Name,U_User,AcctCurrency&$filter=U_User eq ${employeeId} and (AcctCurrency eq '${formData.U_Currency}')`,
					{
						headers: {
							Prefer: 'odata.maxpagesize=10000',
						},
					},
				)
				.then((res) => {
					const data = JSON.parse(res.data).value

					setCashAccountsData(data)

					let defaultAccount = data[0]?.Code

					setFormData((prev) => ({
						...prev,
						U_FromAccount: defaultAccount,
					}))
				})
				.catch((error) => {
					console.error('Error fetching ChartOfAccounts:', error)
					// Optionally, you can handle error UI here
				})

			await api
				.get(
					`ChartOfAccounts?$select=Code,Name,U_User,AcctCurrency&$filter=(${kassaFilter}) and (AcctCurrency eq '${formData.U_Currency}')`,
					{
						headers: {
							Prefer: 'odata.maxpagesize=10000',
						},
					},
				)
				.then((res) => {
					const data = JSON.parse(res.data).value
					setSpendAccountsData(data)

					const cardCode = data[0]?.Code

					setFormData((prev) => ({
						...prev,
						// CardCode: cardCode,
						U_ToAccount: cardCode,
					}))
				})
				.catch((error) => {
					console.error('Error fetching spend accounts:', error)
					// Handle UI or fallback logic here if needed
				})
			setIsLoading(false)
		})()
	}, [formData.U_Currency, getMe])

	const handleSubmit = async () => {
		const filteredCollection = {
			...formData,
			CardCode: undefined,
			CashAccount: undefined,
		}

		const data = {
			U_Sender: senderId,
			U_Receiver: spendAccountsData.find(
				(item) => item.Code === formData.U_ToAccount,
			)?.U_User,
			JOURNALENTRYRCollection: [filteredCollection],
		}
		console.log('data', data)
		// return

		setIsSubmitting(true)
		try {
			await api.post('/DraftJournalEntry', data)
			successModalRef.current?.open('Бугалтерский операция успешно создана!')
		} catch (error) {
			errorRef.current?.open(
				get(JSON.parse(error.response.data), 'error.message', ''),
			)
		} finally {
			setIsSubmitting(false)
		}
	}

	console.log('formData', formData)

	return (
		<Layout>
			<ConstantConsumptionStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle text-xl font-bold text-center py-8">
						Отправить денег в кассу
					</p>
					{/* {isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : ( */}
					<div>
						<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Сумма
								</p>
								<input
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
									}
									type="text"
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											U_PaidSum: removeSpaces(e.target.value),
										}))
									}
									onWheel={(e) => e.target.blur()}
									value={
										formData.U_PaidSum
											? formatNumberWithIntl(formData.U_PaidSum)
											: ''
									}
								/>
							</div>
							<div className="flex flex-col">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Валюта
								</p>
								<select
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
									}
									onChange={(e) => {
										setFormData((prev) => ({
											...prev,
											U_Currency: e.target.value,
										}))
									}}
								>
									<option value="USD">USD</option>
									<option value="UZS">UZS</option>
								</select>
							</div>

							<div className="flex flex-col">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>Дата</p>
								<input
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
									}
									type="date"
									value={formData.U_Date}
									disabled={true}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											U_Date: e.target.value,
										}))
									}
								/>
							</div>
						</div>
						<div className="flex items-center justify-between gap-20">
							<Spin spinning={isLoading}>
								<div>
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										С кассы
									</p>
									<select
										value={formData.U_FromAccount}
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md min-w-[200px]  w-full  flex-1'
										}
										onChange={(e) => {
											setFormData((prev) => ({
												...prev,
												U_FromAccount: e.target.value,
											}))
										}}
										// disabled={
										// 	get(getMe, 'Department2.Name', '') !== 'Boshqaruv'
										// }
									>
										{cashAccountsData
											.filter((item) => item.Code !== formData.CardCode)
											.map((item) => {
												return (
													<option key={item.Code} value={item.Code}>
														{item.Name} - {item.Code}
													</option>
												)
											})}
									</select>
								</div>
							</Spin>
							<Spin spinning={isLoading}>
								<div className="flex flex-col">
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										На кассу
									</p>
									<select
										value={formData.U_ToAccount}
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md min-w-[200px] w-full flex-1'
										}
										defaultValue={formData.U_ToAccount}
										onChange={(e, item) => {
											console.log('item', item)
											setFormData((prev) => ({
												...prev,
												U_ToAccount: e.target.value,
											}))
										}}
									>
										{spendAccountsData
											.filter((item) => item.Code !== formData.CashAccount)
											.map((item) => {
												return (
													<option key={item.Code} value={item.Code} data={item}>
														{item.Name} - {item.Code}
													</option>
												)
											})}
									</select>
								</div>
							</Spin>
						</div>
						<div className="mt-10">
							<p className={'font-medium text-zinc-600 text-sm mb-1'}>
								Комментарий
							</p>
							<textarea
								className={
									'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
								}
								onChange={(e) =>
									setFormData((prev) => ({
										...prev,
										U_Comment: e.target.value,
									}))
								}
								onWheel={(e) => e.target.blur()}
								value={formData.U_Comment}
							/>
						</div>
						<div className="flex justify-end mt-10 gap-10 w-full">
							<Button
								onClick={() => navigation(-1)}
								isLoading={isSubmitting}
								className={'!bg-red-600 !w-full'}
								style={{ width: '100%' }}
							>
								Назад
							</Button>
							<Button
								onClick={handleSubmit}
								isLoading={isSubmitting}
								disabled={
									!formData.U_PaidSum ||
									!formData.U_FromAccount ||
									!formData.U_ToAccount
								}
								style={{ width: '100%' }}
							>
								Добавить
							</Button>
						</div>
					</div>
					{/* )} */}
				</div>
			</ConstantConsumptionStyle>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<SuccessModal
				getRef={(r) => {
					successModalRef.current = r
				}}
				onConfirm={() => {
					navigation('/sent-draft-journal-entries')
				}}
			/>
		</Layout>
	)
}
